import { useQuery, useQueryClient } from "react-query";
import { QUERY_KEYS } from "../../constants/queries";
import { HealthControllerApiFp } from "../../api/generated/v1.0/open";
import { useMemo } from "react";
import { useAxios } from "./useAxios";
import { useQueryWithRefresh } from "./useQueryWithRefresh";
import {
  AppUserControllerApi,
  AppUserControllerApiFp,
} from "../../api/generated/v1.0/app";
import { useAuth } from "./useAuth";

export const useCheckDuplicateEmail = () => {
  const { auth, setAuth, isLoggedIn } = useAuth();
  const { user, accessToken } = auth;
  // if (user == null) {
  //   throw new Error("User is null");
  // }
  const axios = useAxios();

  const queryClient = useQueryClient();
  const invalidateQuery = () =>
    queryClient.invalidateQueries([QUERY_KEYS.checkDuplicateEmail]);
  const res = useQueryWithRefresh(
    [QUERY_KEYS.checkDuplicateEmail, accessToken, user.id],
    async () => {
      // if current date < March 26th 2025, return false
      const currentDate = new Date();
      const targetDate = new Date("2025-03-26");
      if (currentDate < targetDate) {
        return false;
      }
      const res = await (
        await AppUserControllerApiFp().hasDuplicateEmailUsingGET(
          accessToken,
          user.id!
        )
      )(axios);
      return res.data;
    },
    {
      enabled: !!accessToken && !!user?.id,
      refetchInterval: 60000,
    }
  );

  return { ...res, invalidateQuery };
};
